export default __webpack_public_path__ + "static/media/arrowDownOrange.92e19ef5.svg";